import { AttributeFilterController } from '../attribute-filter.component';

import template from './numeric-range-filter.component.html';

class NumericRangeController extends AttributeFilterController {
	constructor($filter) {
		'ngInject';
		super();

		this.translateFilter = $filter('translate');
	}

	$onInit() {
		this.attr.selectedRange = this.attr.selectedRange || {};
		this.setHelp();
	}

	setHelp() {
		this.getHelp({ help: 'numericRange' });
	}

	getTranslation(text) {
		return text.length > 0 ? this.translateFilter(text) : text;
	}

	getRangeStartPlaceholder() {
		let text = '';
		if (this.attr.range) {
			const { min } = this.attr.range;
			text = min ? `Enter a value of at least ${min}` : `Enter a number`;
		}
		return this.getTranslation(text);
	}

	getRangeEndPlaceholder() {
		let text = '';
		if (this.attr.range) {
			const { max } = this.attr.range;
			text = max ? `Enter a value no greater than ${max}` : `Enter a number`;
		}
		return this.getTranslation(text);
	}

	toggleAnyValue() {
		this.attr.anyValue = !this.attr.anyValue;
	}

	entryInvalid(field) {
		return !!field && field.$touched && Object.keys(field.$error).length > 0;
	}

	getErrorType(field) {
		if (this.hasRequiredError(field)) {
			return 'required';
		} else if (this.hasInvalidMin(field)) {
			return 'min';
		} else if (this.hasInvalidMax(field)) {
			return 'max';
		} else if (this.hasInvalidPattern(field)) {
			return `${this.attr.rawAttr.dataType.toLowerCase()}-pattern`;
		}
	}

	hasRequiredError(field) {
		return super.supportsError(field) && !!field.$error.required;
	}

	hasInvalidMin(field) {
		return super.supportsError(field) && !!field.$error.min;
	}

	hasInvalidMax(field) {
		return super.supportsError(field) && !!field.$error.max;
	}

	hasInvalidPattern(field) {
		return super.supportsError(field) && (!!field.$error.pattern || !!field.$error.number);
	}
}

export const numericRangeFilterComponent = {
	template,
	controller: NumericRangeController,
	controllerAs: 'vm',
	bindings: {
		attr: '<',
		getHelp: '&'
	}
};
